"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _a, _LayoutNode_client, _TabStack_client, _ColumnOrRow_client;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnOrRow = exports.TabStack = exports.LayoutNode = void 0;
const api_exposer_1 = require("../../../api-exposer");
const channel_api_relay_1 = require("../../../../util/channel-api-relay");
/*
    This file includes LayoutNode, ColumnOrRow and TabStack classes, which are all closely
    intertwined, and share members via parent abstract class LayoutNode. To prevent circular
    refs, we define and export all the classes here.
*/
/**
 * @ignore
 * @internal
 * Supplies an ApiClient for {@link LayoutEntitiesController} and helper methods
 * for the entities {@link TabStack} AND {@link ColumnOrRow} to use.
 */
class LayoutNode {
    /**
     * @internal
     * @ignore
     */
    constructor(client, entityId) {
        /**
         * @ignore
         * @internal
         * ApiClient for {@link LayoutEntitiesController}
         */
        _LayoutNode_client.set(this, void 0);
        this.isRoot = () => __classPrivateFieldGet(this, _LayoutNode_client, "f").isRoot(this.entityId);
        this.exists = () => __classPrivateFieldGet(this, _LayoutNode_client, "f").exists(this.entityId);
        this.getParent = async () => {
            const parent = await __classPrivateFieldGet(this, _LayoutNode_client, "f").getParent(this.entityId);
            if (!parent) {
                return undefined;
            }
            return LayoutNode.getEntity(parent, __classPrivateFieldGet(this, _LayoutNode_client, "f"));
        };
        this.createAdjacentStack = async (views, options) => {
            const entityId = await __classPrivateFieldGet(this, _LayoutNode_client, "f").createAdjacentStack(this.entityId, views, options);
            return LayoutNode.getEntity({ entityId, type: 'stack' }, __classPrivateFieldGet(this, _LayoutNode_client, "f"));
        };
        this.getAdjacentStacks = async (edge) => {
            const adjacentStacks = await __classPrivateFieldGet(this, _LayoutNode_client, "f").getAdjacentStacks({
                targetId: this.entityId,
                edge
            });
            return adjacentStacks.map((stack) => LayoutNode.getEntity({
                type: 'stack',
                entityId: stack.entityId
            }, __classPrivateFieldGet(this, _LayoutNode_client, "f")));
        };
        __classPrivateFieldSet(this, _LayoutNode_client, client, "f");
        this.entityId = entityId;
    }
}
exports.LayoutNode = LayoutNode;
_a = LayoutNode, _LayoutNode_client = new WeakMap();
/**
 * @ignore
 * @internal
 * Encapsulates Api consumption of {@link LayoutEntitiesController} with a relayed dispatch
 * @param client
 * @param controllerId
 * @param identity
 * @returns a new instance of {@link LayoutEntitiesClient} with bound to the controllerId
 */
LayoutNode.newLayoutEntitiesClient = async (client, controllerId, identity) => {
    const dispatch = (0, channel_api_relay_1.createRelayedDispatch)(client, identity, 'layout-relay', 'You are trying to interact with a layout component on a window that has been destroyed.');
    const consumer = new api_exposer_1.ApiConsumer(new api_exposer_1.ChannelsConsumer({ dispatch }));
    return consumer.consume({ id: controllerId });
};
LayoutNode.getEntity = (definition, client) => {
    const { entityId, type } = definition;
    switch (type) {
        case 'column':
        case 'row':
            return new ColumnOrRow(client, entityId, type);
        case 'stack':
            return new TabStack(client, entityId);
        default:
            throw new Error(`Unrecognised Layout Entity encountered ('${JSON.stringify(definition)})`);
    }
};
/**
 * @typedef {string} LayoutPosition
 * @summary Represents the position of an item in a layout relative to another. Possible values are 'top', 'bottom', 'left' and 'right'.
 */
/**
 * @typedef {object} StackCreationOptions
 * @summary Stack creation options.
 * @property {LayoutPosition} [position] - The position to create the new {@link TabStack} in, relative to the given adjacent {@link TabStack}. Defaults to 'right'.
 */
/**
 * @typedef {object} TabStack~AddViewOptions
 * @summary Options to use when adding a view to a {@link TabStack}
 * @property {number} [index] - Insertion index when adding the view. Defaults to 0.
 */
/**
 * A TabStack is used to manage the state of a stack of tabs within an OpenFin Layout.
 */
class TabStack extends LayoutNode {
    /**
     * Determines if this {@link TabStack} is the top level content item in the current layout.
     * @function isRoot
     * @memberof TabStack
     * @instance
     * @tutorial TabStack.isRoot
     * @return {Promise<boolean>} Resolves true if this TabStack is the top level content item, or false if it is not.
     */
    /**
     * Determines if this  {@link TabStack} exists.
     * @function exists
     * @instance
     * @memberof TabStack
     * @tutorial TabStack.exists
     * @return {Promise<boolean>} Resolves true if this is the TabStack exists, or false if it has been destroyed.
     */
    /**
     * Retrieves the parent {@link ColumnOrRow} of this {@link TabStack}, if one exists.
     * @function getParent
     * @instance
     * @memberof TabStack
     * @tutorial TabStack.getParent
     * @return {Promise<ColumnOrRow | TabStack | undefined>} Promise resolving with the {@link ColumnOrRow} that contains this item, or undefined if this {@link TabStack} is the root content item or does not exist.
     */
    /**
     * Returns all the adjacent stacks that share an edge with the given {@link TabStack}.
     * @function getAdjacentStacks
     * @instance
     * @memberof TabStack
     * @param  {LayoutPosition} edge - Edge to check for any adjacent stacks.
     * @returns {Promise<TabStack[]>}
     * @tutorial TabStack.getAdjacentStacks
     */
    /**
     * Given a list of view creation options or references and a layout position, creates a {@link TabStack} adjacent to the current {@link TabStack}
     *
     * Known Issue: If the number of views to add overflows the tab-container, the added views will be set as active
     * during each render, and then placed at the front of the tab-stack, while the underlying order of tabs will remain unchanged.
     * This means the views you pass to createAdjacentStack() may not render in the order given by the array.
     * Until fixed, this problem can be avoided only if your window is wide enough to fit creating all the views in the tabstack.
     *
     * @function createAdjacentStack
     * @instance
     * @memberof TabStack
     * @param {View~options} views - List of identities or view creation options of the views to include in the stack
     * @param {StackCreationOptions} options - Creation options.
     * @returns {Promise<TabStack>} The created TabStack.
     * @tutorial TabStack.createAdjacentStack
     * @experimental
     */
    /** @internal */
    constructor(client, entityId) {
        super(client, entityId);
        /**
         * @internal
         * ApiClient for {@link LayoutEntitiesController}
         */
        _TabStack_client.set(this, void 0);
        /**
         * Type of the content item. Always stack, but useful for distinguishing between a {@link TabStack} and {@link ColumnOrRow}.
         */
        this.type = 'stack';
        /**
         * Retrieves a list of all views belonging to this {@link TabStack}.
         *
         * Known Issue: If adding a view overflows the tab-container width, the added view will be set as active
         * and rendered at the front of the tab-stack, while the underlying order of tabs will remain unchanged.
         * If that happens and then getViews() is called, it will return the identities in a different order than
         * than the currently rendered tab order.
         *
         * @returns {Promise<Identity[]>} Resolves with a list containing the {@link OpenFin.Identity identities} of each view belonging to the {@link TabStack}.
         * @throws If the {@link TabStack} has been destroyed.
         * @tutorial TabStack.getViews
         * @experimental
         */
        this.getViews = () => __classPrivateFieldGet(this, _TabStack_client, "f").getStackViews(this.entityId);
        /**
         * Adds or creates a view in this {@link TabStack}.
         *
         * Known Issue: If adding a view overflows the tab-container, the added view will be set as active
         * and rendered at the front of the tab-stack, while the underlying order of tabs will remain unchanged.
         *
         * @param {View~options} view The identity of an existing view to add, or options to create a view.
         * @param {TabStack~AddViewOptions} options Optional view options: index number used to insert the view into the stack at that index. Defaults to 0 (front of the stack)
         * @returns {Promise<identity>} Resolves with the {@link OpenFin.Identity identity} of the added view.
         * @throws If the view does not exist or fails to create.
         * @throws If the {@link TabStack} has been destroyed.
         * @tutorial TabStack.addView
         * @experimental
         */
        this.addView = async (view, options = { index: 0 }) => __classPrivateFieldGet(this, _TabStack_client, "f").addViewToStack(this.entityId, view, options);
        /**
         * Removes a view from this {@link TabStack}.
         * @param {Identity} view - Identity of the view to remove.
         * @throws If the view does not exist or does not belong to the stack.
         * @throws If the {@link TabStack} has been destroyed.
         * @return {Promise<void>}
         * @tutorial TabStack.removeView
         */
        this.removeView = async (view) => {
            await __classPrivateFieldGet(this, _TabStack_client, "f").removeViewFromStack(this.entityId, view);
        };
        /**
         * Sets the active view of the {@link TabStack} without focusing it.
         * @param {Identity} view - Identity of the view to activate.
         * @returns {Promise<void>} Promise which resolves with void once the view has been activated.
         * @throws If the {@link TabStack} has been destroyed.
         * @throws If the view does not exist.
         * @tutorial TabStack.setActiveView
         * @experimental
         */
        this.setActiveView = async (view) => {
            await __classPrivateFieldGet(this, _TabStack_client, "f").setStackActiveView(this.entityId, view);
        };
        __classPrivateFieldSet(this, _TabStack_client, client, "f");
    }
}
exports.TabStack = TabStack;
_TabStack_client = new WeakMap();
/**
 * A ColumnOrRow is used to manage the state of Column and Rows within an OpenFin Layout.
 */
class ColumnOrRow extends LayoutNode {
    /**
     * Determines if this {@link ColumnOrRow} is the top level content item in the current layout.
     * @function isRoot
     * @memberof ColumnOrRow
     * @instance
     * @tutorial ColumnOrRow.isRoot
     * @return {Promise<boolean>} Resolves true if this TabStack is the top level content item, or false if it is not.
     */
    /**
     * Determines if this  {@link ColumnOrRow} exists.
     * @function exists
     * @instance
     * @memberof ColumnOrRow
     * @tutorial ColumnOrRow.exists
     * @return {Promise<boolean>} Resolves true if the TabStack exists, or false if it has been destroyed.
     */
    /**
     * Retrieves the parent {@link ColumnOrRow} of this {@link ColumnOrRow}, if one exists.
     * @function getParent
     * @instance
     * @memberof ColumnOrRow
     * @tutorial ColumnOrRow.getParent
     * @return {Promise<ColumnOrRow | undefined>} Promise resolving with the {@link ColumnOrRow} that contains this item, or undefined if this {@link ColumnOrRow} does not exist or is the root content item.
     */
    /**
     * Returns all the adjacent stacks that share an edge with the given {@link ColumnOrRow}.
     * @function getAdjacentStacks
     * @instance
     * @memberof ColumnOrRow
     * @param  {LayoutPosition} edge - Edge to check for any adjacent stacks.
     * @returns {Promise<TabStack[]>}
     * @tutorial ColumnOrRow.getAdjacentStacks
     */
    /**
     * Given a list of view creation options or references and a layout position, creates a {@link TabStack} adjacent to the given {@link ColumnOrRow}
     *
     * Known Issue: If the number of views to add overflows the tab-container, the added views will be set as active
     * during each render, and then placed at the front of the tab-stack, while the underlying order of tabs will remain unchanged.
     * This means the views you pass to createAdjacentStack() may not render in the order given by the array.
     * Until fixed, this problem can be avoided only if your window is wide enough to fit creating all the views in the tabstack.
     *
     * @function createAdjacentStack
     * @instance
     * @memberof ColumnOrRow
     * @param {View~options} views - List of identities or view creation options of the views to include in the stack
     * @param {StackCreationOptions} options - Creation options.
     * @returns {Promise<TabStack>} The created TabStack
     * @tutorial ColumnOrRow.createAdjacentStack
     * @experimental
     */
    /**
     * @internal
     */
    constructor(client, entityId, type) {
        super(client, entityId);
        /**
         * @ignore
         * @internal
         * ApiClient for {@link LayoutEntitiesController}
         */
        _ColumnOrRow_client.set(this, void 0);
        /**
         * Retrieves a list of all content items belonging to this {@link ColumnOrRow} in order of appearance.
         * @returns {Promise<Array<ColumnOrRow | TabStack>>} Resolves with a list containing {@link ColumnOrRow} and {@link TabStack} items belonging to this {@link ColumnOrRow}.
         * @tutorial ColumnOrRow.getContent
         */
        this.getContent = async () => {
            const contentItemEntities = await __classPrivateFieldGet(this, _ColumnOrRow_client, "f").getContent(this.entityId);
            return contentItemEntities.map((entity) => LayoutNode.getEntity(entity, __classPrivateFieldGet(this, _ColumnOrRow_client, "f")));
        };
        __classPrivateFieldSet(this, _ColumnOrRow_client, client, "f");
        this.type = type;
    }
}
exports.ColumnOrRow = ColumnOrRow;
_ColumnOrRow_client = new WeakMap();
